import { Dispatcher } from 'flux'

class AppDispatcherClass extends Dispatcher {}

const AppDispatcher = new AppDispatcherClass()

export default AppDispatcher



// WEBPACK FOOTER //
// ./src/app/dispatcher/Dispatcher.js